(function () {
  // === KONFIG ===
  // Sett din Qualtrics-URL (UTEN PID-verdien)
  // Eksempel: "https://yourcompany.qualtrics.com/jfe/form/XXXXXXXX"
  var QUALTRICS_BASE = "https://biedu.qualtrics.com/jfe/form/SV_6ssxazNxYyhxkJ8"; // <-- BYTT UT
  var PID_PARAM = "PID";

  // === HJELPERE ===
  function buildLink(email) {
    try {
      var url = new URL(QUALTRICS_BASE);
      url.searchParams.set(PID_PARAM, email);
      return url.toString();
    } catch (e) {
      // Fallback hvis URL() ikke finnes
      var sep = QUALTRICS_BASE.indexOf("?") === -1 ? "?" : "&";
      return QUALTRICS_BASE + sep + PID_PARAM + "=" + email;
    }
  }

  function slugify(str) {
    return String(str || "")
      .toLowerCase()
      .trim()
      .normalize("NFD")            // fjern diakritiske tegn
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9+ ]+/g, "") // behold tall, bokstaver og +
      .replace(/\s+/g, "-");
  }

  function digitsOnly(str) {
    return String(str || "").replace(/\D+/g, "");
  }

  function mergeTags(existing, toAddArr) {
    var base = String(existing || "")
      .split(",")
      .map(function (t) { return t.trim().toLowerCase(); })
      .filter(Boolean);

    toAddArr.forEach(function (t) {
      var v = String(t || "").trim().toLowerCase();
      if (v && base.indexOf(v) === -1) base.push(v);
    });

    return base.join(",");
  }

  // === SUBMIT: samle felter og oppdater tags/success-state ===
  document.addEventListener("submit", function (e) {
    if (!e.target || e.target.id !== "mysterybox-form") return;

    var name     = document.getElementById("mbx-name")?.value?.trim() || "";
    var address  = document.getElementById("mbx-address")?.value?.trim() || "";
    var postcode = document.getElementById("mbx-postcode")?.value?.trim() || "";
    var email    = document.getElementById("mbx-email")?.value?.trim() || "";
    var phone    = document.getElementById("mbx-phone")?.value?.trim() || "";
    var box      = (document.querySelector('input[name="mbx-box"]:checked') || {}).value || "";

    // lagre e-post for success-skjerm
    if (email) sessionStorage.setItem("mbx_email", email);

    // Bygg dynamiske tags av alle feltene (since customer note ikke lagres fra public form)
    var dynTags = [];
    if (name)     dynTags.push("name-" + slugify(name));
    if (address)  dynTags.push("address-" + slugify(address));
    if (postcode) dynTags.push("postcode-" + digitsOnly(postcode));
    if (phone)    dynTags.push("phone-" + digitsOnly(phone));
    if (box)      dynTags.push(box); // box-a eller box-b

    // Slå sammen med eksisterende hidden tags-input
    var tagsInput = document.getElementById("mbx-tags");
    if (tagsInput) {
      tagsInput.value = mergeTags(tagsInput.value, dynTags);
    }
  });

  // === SUCCESS-VISNING: sett CTA-lenke ===
  document.addEventListener("DOMContentLoaded", function () {
    var successEl = document.querySelector('[data-mbx-success="true"]');
    if (!successEl) return;

    var email = (sessionStorage.getItem("mbx_email") || "").trim();
    if (!email) return;

    var a = document.getElementById("mbx-link");
    if (a) {
      a.href = buildLink(encodeURIComponent(email));
      // Hvis du vil vise eposten i knappeteksten, uncomment:
      // a.textContent = "Gå til undersøkelsen (" + email + ")";
    }
  });
})();
